import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import translate from "../../../i18n/translate";
import { getMySounds } from "../../../redux/actions/soundsOfEnglishActions";
import ErrorPage from "../../shared/ErrorPage/ErrorPage";
import Loader from "../../shared/Loader/Loader";
import { LANGUAGE_CODES, PHONEME_DATA_LIST } from "./FeatureCourse/constants";
import { refreshHighlight } from "./FeatureCourse/speechService";
import "./soundsOfEnglish.scss";

const SoundsOfEnglish = () => {
  const dispatch = useDispatch();
  const [isAccessible, setIsAccessible] = React.useState<boolean | null>(null);
  const [showLoader, setShowLoader] = React.useState<boolean>(true);
  const [selectedCode, setSelectedCode] = useState<number>(1);
  const [vowelsList, setVowelsList] = useState<any>([]);
  const [consonantsList, setConsonantsList] = useState<any>([]);
  const [newHighLightIds, setNewHighLightIds] = useState<any[]>([]);
  const userStateDetails = useSelector((state: any) => state.peopleInformation);
  const { data } = useSelector((state: any) => state.soundsOfEnglish);

  const handleLanguageSelect = async (e: any) => {
    setNewHighLightIds([]);
    setSelectedCode(e.target.value);
    const highlighValue: any = refreshHighlight(e.target.value, data);
    setNewHighLightIds(highlighValue ?? []);
  };

  useEffect(() => {
    if (userStateDetails && userStateDetails.data && userStateDetails.data.getpeopleInformation) {
      const getPeopleInformation = userStateDetails.data.getpeopleInformation;
      if (getPeopleInformation.serviceConfiguration.features.substring(53, 54) !== "1") {
        setIsAccessible(false);
      } else if (getPeopleInformation.serviceConfiguration.features.substring(53, 54) === "1") {
        setIsAccessible(true);
        dispatch(getMySounds(getPeopleInformation.edgeUid));
      }
      setShowLoader(false);
    }

    if (PHONEME_DATA_LIST.length > 0) {
      const VOWELS_LIST = PHONEME_DATA_LIST.slice().splice(0, 15);
      setVowelsList(VOWELS_LIST);
      const CONSONANTS_LIST = PHONEME_DATA_LIST.slice().splice(15, PHONEME_DATA_LIST.length - 14);
      setConsonantsList(CONSONANTS_LIST);
    }
  }, [userStateDetails]);

  const redirectToEdgeSOE = (path: string) => {
    window.open(`${process.env.REACT_APP_PROGRESS_URL}${path}?isSimplified=true`, "_blank");
  };

  const toEdgeActivityPlayer = (activityId: string) => {
    window.open(`${process.env.REACT_APP_PROGRESS_URL}/SoundsOfEnglish/${activityId}?isSimplified=true`, "_blank");
  };

  const checkIdInHighLightArray = (id: any) => {
    return newHighLightIds.includes(id);
  };

  return isAccessible === null ? (
    <Loader showLoader={showLoader} />
  ) : isAccessible ? (
    <div className="sounds-of-english-wrapper">
      <div className="sounds-of-english-container">
        <div className="feature-details-header">
          <h5 className="feature-title">{translate("soe_product_headline")}</h5>
          <div className="feature-description-box">
            <div className="feature-description-wrapper">
              <p className="feature-description">{translate("soe_product_description")}</p>
              <p className="feature-select-language">{translate("soe_product_language_selection")}</p>
              <div className="feature-language-selection-box">
                <select value={selectedCode} onChange={handleLanguageSelect} className="feature-language-select">
                  {LANGUAGE_CODES.map((codes: any, index: number) => (
                    <option key={index} value={codes.id} className="feature-language-option">
                      {codes.title}
                    </option>
                  ))}
                </select>
                <div className="feature-language-message">
                  <p className="feature-language-dot">●</p>
                  <p className="feature-language-words">= Focus on these sounds.</p>
                </div>
              </div>
            </div>
            {/* <img
            src={require("./FeatureCourse/featureImage.png")}
            alt="Sounds of English Feature Image"
            className="feature-image"
          /> */}
          </div>
        </div>
        <div className="soe-detail-wrapper">
          <div className="soe-vowels-container">
            <p className="container-title">{translate("soe_product_vowels")}</p>
            <div className="each-vocab-boxes">
              {vowelsList.map((vowelsList: any) => (
                <div
                  key={`${vowelsList.Id}`}
                  className={`each-vocab-box ${checkIdInHighLightArray(vowelsList.Id) ? "highlight" : ""}`}
                  onClick={() => toEdgeActivityPlayer(vowelsList.phoneme)}
                >
                  <p className="each-vocab-symbol">{vowelsList.symbol}</p>
                  <p
                    className="each-vocab-word"
                    dangerouslySetInnerHTML={{ __html: `(${vowelsList.Words[0] ?? ""})` }}
                  ></p>
                </div>
              ))}
            </div>
            <div className="soe-vowel-activities">
              <p
                onClick={() => redirectToEdgeSOE("/SoundsOfEnglish/6174/132421")}
                className={`activity-title ${checkIdInHighLightArray(6174) ? "highlight" : ""}`}
              >
                Long and Short Vowels
                <span className="highlight-dot">●</span>
              </p>
            </div>
          </div>
          <div className="soe-consonants-container">
            <p className="container-title">{translate("soe_product_consonants")}</p>
            <div className="each-vocab-boxes">
              {consonantsList.map((consonantsList: any) => (
                <div
                  key={`${consonantsList.Id}`}
                  className={`each-vocab-box ${checkIdInHighLightArray(consonantsList.Id) ? "highlight" : ""}`}
                  onClick={() => toEdgeActivityPlayer(consonantsList.phoneme)}
                >
                  <p className="each-vocab-symbol">{consonantsList.symbol}</p>
                  <p
                    className="each-vocab-word"
                    dangerouslySetInnerHTML={{ __html: `(${consonantsList.Words[0] ?? ""})` }}
                  ></p>
                </div>
              ))}
            </div>
            <div className="soe-consonants-activities">
              <p
                onClick={() => redirectToEdgeSOE("/SoundsOfEnglish/6177/132571")}
                className={`activity-title ${checkIdInHighLightArray(6177) ? "highlight" : ""}`}
              >
                -ed Endings
                <span className="highlight-dot">●</span>
              </p>
              <p
                onClick={() => redirectToEdgeSOE("/SoundsOfEnglish/6155/131473")}
                className={`activity-title ${checkIdInHighLightArray(6155) ? "highlight" : ""}`}
              >
                Groups at the Ends of Words
                <span className="highlight-dot">●</span>
              </p>
              <p
                onClick={() => redirectToEdgeSOE("/SoundsOfEnglish/6154/131424")}
                className={`activity-title ${checkIdInHighLightArray(6154) ? "highlight" : ""}`}
              >
                Groups at the Beginnings of Words
                <span className="highlight-dot">●</span>
              </p>
              <p
                onClick={() => redirectToEdgeSOE("/SoundsOfEnglish/6179/132671")}
                className={`activity-title ${checkIdInHighLightArray(6179) ? "highlight" : ""}`}
              >
                Final -s
                <span className="highlight-dot">●</span>
              </p>
              <p
                onClick={() => redirectToEdgeSOE("/SoundsOfEnglish/6162/131835")}
                className={`activity-title ${checkIdInHighLightArray(6162) ? "highlight" : ""}`}
              >
                Hard and Soft Letters
                <span className="highlight-dot">●</span>
              </p>
              <p
                onClick={() => redirectToEdgeSOE("/SoundsOfEnglish/6178/132621")}
                className={`activity-title ${checkIdInHighLightArray(6178) ? "highlight" : ""}`}
              >
                Voiced and Unvoiced Sounds
                <span className="highlight-dot">●</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <ErrorPage status={401} />
  );
};

export default SoundsOfEnglish;
